import startCase from 'lodash/startCase'

/**
 * Capitalizes a string using lodash's startCase, but forces common prepositions
 * to be lowercase, except if they are the first word.
 *
 * @param {string} str The string to modify.
 * @returns {string} The modified string.
 */
export const lowerCasePrepositions = (str: string): string => {
  const startCased = startCase(str)
  const prepositions = [
    'a',
    'an',
    'the',
    'and',
    'but',
    'or',
    'for',
    'nor',
    'so',
    'at',
    'by',
    'to',
    'in',
    'on',
    'of',
    'up'
  ]

  const words = startCased.split(' ')

  const modifiedWords = words.map((word, index) => {
    const isPreposition = prepositions.includes(word.toLowerCase())

    if (isPreposition && index > 0) {
      return word.toLowerCase()
    }
    return word
  })

  return modifiedWords.join(' ')
}
